import { IUserCalendar } from '@commenda/types/src/user';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export function useUserLegacyCalendar(
  username: string | undefined, // calcom username
  eventSlug?: string
) {
  const requestBaseURI = username ? `user/legacy/calendar/${username}` : null;

  const requestURI =
    eventSlug && requestBaseURI
      ? `${requestBaseURI}?eventSlug=${eventSlug}`
      : requestBaseURI;

  const {
    data,
    error,
    mutate,
  }: {
    data?: IUserCalendar;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    requestURI,
    SWRFetcher(
      {
        method: 'GET',
      },
      ''
    )
  );

  return {
    data,
    error,
    mutate,
  };
}
